
    import Vue from "vue";
    import { ApiClient } from "@/utilities/ApiClient";
    import Component from "vue-class-component";
    import { Authentication } from "@/utilities/Authentication";
    import store from "@/store/store";
    import Bookings from "@/views/Bookings.vue";
    import EventBus from "@/utilities/EventBus";
    import { Utils } from "@/utilities/Utils";
    import { Contractor } from "../model/Contractor";
    import { User, IUser } from "../model/User";

    @Component({
        components: {
            Bookings
        }
    })

    export default class SignedInLayout extends Vue {

        private contractor = new Contractor();
        imageUrl: string = "";
        contractorKey: string = "";
        contractorName: string = "";
        private signedInUser = new User();
        printServiceUrl: string = "";


        async mounted() {
            document.body.style.backgroundColor = "#fff";
            this.signedInUser = this.$store.state.signedInUser;
            this.getImageUrl();
            this.getPrintServiceUrl();
        }

        async getImageUrl() {
            if (this.signedInUser.role == 3) {
                const contractorServerData = await ApiClient.get(`Api/Contractor/GetContractor?id=${store.state.signedInUser?.guid}`);
                this.contractor.update(contractorServerData)
            }
            if (this.signedInUser.role == 4) {
                const contractorServerData = await ApiClient.get(`Api/Contractor/GetContractorManager?id=${store.state.signedInUser?.guid}`);
                this.contractor.update(contractorServerData)
            }
            this.contractorKey = this.contractor.image.key;
            this.contractorName = this.contractor.name;
            this.imageUrl = Utils.isEmptyId(this.contractorKey) ? "" : await ApiClient.resolveUrl(`api/contractor/Image?key=${this.contractorKey}`);
            //console.log(this.imageUrl)
        }

        async getPrintServiceUrl() {
            const data = await ApiClient.get(`Api/lookup/printServiceUrl`);
            this.printServiceUrl = data;
        }

        get signedInUserName(): string {
            return store.getters.signedInUserName;
        }

        get isTest(): boolean {
            return this.$store.state.isTestEnviroment == true;
        }

        signOut() {
            // Not using async / await here so we'll just trust the sign out occurs in the background
            // and rely on error handler if anything screws up.
            Authentication.signOut();

            this.$router.push("/");
        }

        get returnBadge(): boolean {
            return !Utils.isEmptyId(this.$store.state.bookingID);
        }

        async returnToBooking() {
            const bookingID = this.$store.state.bookingID;
            if (this.$router.currentRoute.path.toLowerCase().indexOf("/bookings") == -1) {
                await this.$router.push("/bookings");
            }
            EventBus.$emit("editBooking", bookingID);
        }

        clearReturnBadge() {
            store.dispatch("setBookingID", null)
        }

    }
